/** Log handler type to indicate using different sdks (e.g uteljs) to send events*/ export var LogHandlerType;
(function(LogHandlerType) {
    /** Use Uteljs */ LogHandlerType[LogHandlerType["UTel"] = 0] = "UTel";
})(LogHandlerType || (LogHandlerType = {}));
